import moment from "moment/moment";
import { useContext, useEffect, useRef } from "react";
import { createContext, useState } from "react";

import AuthContext from "./AuthContext";
import CorporateFacilityContext from "./CorporateFacilityContext";
import { API } from "aws-amplify";
import awsConfig from "../aws-config";
import { getSpeak2Profile } from "../Apps/Speak2ContentAPIs/Speak2Profile.js";
import {
  isCorporateProfile,
  readActiveCorporateFacility,
} from "../utils/corporateFacilityStorage";
import LoaderController from "../Controllers/LoaderController.js";
import useToastify from "../hooks/useToastify.js";

API.configure(awsConfig);

const ShareContext = createContext();
export default ShareContext;

export const ShareContextProvider = ({ children }) => {
  const { UserName, UserId, IsSpeak2User, handleLogOut } = useContext(AuthContext);
  const [CommunityContentData, setCommunityContentData] = useState([]);
  const [CommunityContentLoader, setCommunityContentLoader] = useState(false);
  const [UpdateTemplateUseAndRatingLoader, setUpdateTemplateUseAndRatingLoader] = useState(false);
  const [IsSpeak2Admin, setIsSpeak2Admin] = useState(false);
  const [Speak2UserEmailAsOrganizationId, setSpeak2UserEmailAsOrganizationId] = useState(null);
  const NumberOfPagesToDisplayOnPagination = 5;
  const [PageSize, setPageSize] = useState(15);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [TotalNumberOfDesignTemplates, setTotalNumberOfDesignTemplates] = useState(15);
  const [IsLoadedAllCommunityContentTemplates, setIsLoadedAllCommunityContentTemplates] =
    useState(false);
  const [FacilityAndCorporateIdObject, setFacilityAndCorporateIdObject] = useState(null);
  const { showNotification } = useToastify();
  const corporateCtx = useContext(CorporateFacilityContext);
  const activeFacilityId = corporateCtx?.activeFacility?.facilityId ?? null;
  const facilityRequestIdRef = useRef(0);
  useEffect(() => {
    facilityRequestIdRef.current += 1;
    setFacilityAndCorporateIdObject(null);
    if (!UserId) return;
    getUserOrganizationEmail();
    getCorporateGroupAndCommunitiesList();
  }, [UserId, activeFacilityId]);

  // Get Community Content
  const getCommunityContentTemplates = async (currentpage = 1) => {
    setCommunityContentLoader(true);
    try {
      let organizationEmailId = Speak2UserEmailAsOrganizationId;
      if (organizationEmailId === null) {
        organizationEmailId = await getUserOrganizationEmail();
      }
      let corporateandfacilityobject = FacilityAndCorporateIdObject;
      if (corporateandfacilityobject === null) {
        corporateandfacilityobject = await getCorporateGroupAndCommunitiesList();
      }
      setCommunityContentLoader(true);
      const response = await API.get("Community-Content-Templates", "/community-content", {
        response: true,
        queryStringParameters: {
          page: currentpage,
          limit: IsLoadedAllCommunityContentTemplates === true ? 15 : PageSize,
        },
      });
      // console.log("Data for images is ",JSON.stringify(response.data));
      let filteredCommunityContent = response.data.data;
      setTotalNumberOfDesignTemplates(response.data.totalTemplates);
      if (IsLoadedAllCommunityContentTemplates === true) {
        setIsLoadedAllCommunityContentTemplates(false);
        setPageSize(15);
      }

      filteredCommunityContent = response.data.data.filter((template) => {
        //  console.log("Template Shared To is ",template.TemplateSharedTo);
        // if(organizationEmailId!==null)
        // {
        //   console.log("I am here for "+template.OrganizationSharedBy);
        //   if(template.OrganizationSharedBy===null)
        //   {
        //     return true;
        //   }
        //   return (template.OrganizationSharedBy!==undefined&&template.OrganizationSharedBy.split('@')[1]===organizationEmailId.split('@')[1]) || template.IsPublic===true || template.IsPublic===undefined;
        // }
        if (
          template.IsPublic === false &&
          template.TemplateSharedTo &&
          corporateandfacilityobject != null
        ) {
          if (
            corporateandfacilityobject.FacilityId === template.TemplateSharedTo.FacilityId ||
            corporateandfacilityobject.CorporateId === template.TemplateSharedTo.CorporateId
          ) {
            return true;
          } else {
            return false;
          }
        }
        console.log("below the belt " + template.OrganizationSharedBy);
        return template.IsPublic === true || template.IsPublic === undefined;
      });
      // console.log("Filtered Community Content is ",filteredCommunityContent);
      setSpeak2UserEmailAsOrganizationId(organizationEmailId);
      filteredCommunityContent = handleAddCustomFontsList(filteredCommunityContent);
      setCommunityContentData(filteredCommunityContent);
      setCommunityContentLoader(false);
    } catch (error) {
      setCommunityContentLoader(false);
      console.log("error fetching design templates", error);
    }
    setCommunityContentLoader(false);
  };

  const getCommunityContentTemplatesPaginated = async (page = 1, templateType, pageWidth, pageHeight, sortBy = 'most-recent', filterMode = null, filterParams = {}, search = '') => {
    setCommunityContentLoader(true);
    try {
      const queryParams = { mode: 'paginated', page, limit: 15, sortBy };
      if (templateType) queryParams.templateType = templateType;
      if (pageWidth) queryParams.pageWidth = pageWidth;
      if (pageHeight) queryParams.pageHeight = pageHeight;
      if (filterMode) queryParams.filterMode = filterMode;
      if (filterParams.userId) queryParams.userId = filterParams.userId;
      if (filterParams.facilityId) queryParams.facilityId = filterParams.facilityId;
      if (filterParams.corporateId) queryParams.corporateId = filterParams.corporateId;
      if (filterParams.orgDomain) queryParams.orgDomain = filterParams.orgDomain;
      if (search) queryParams.search = search;
      const response = await API.get('Community-Content-Templates', '/community-content', {
        response: true,
        queryStringParameters: queryParams,
      });
      setCommunityContentLoader(false);
      return { templates: handleAddCustomFontsList(response.data.data || []), total: response.data.totalTemplates || 0 };
    } catch (error) {
      setCommunityContentLoader(false);
      console.log('error fetching paginated templates', error);
      return { templates: [], total: 0 };
    }
  };

  const loadAllCommunityContentTemplates = async () => {
    setCommunityContentLoader(true);
    let FilteredCommunityTemplates = [];
    let pagesize = PageSize;
    let responcesize = PageSize;
    let pagenumber = 1;
    let totalTemplates = 0;

    let corporateandfacilityobject = FacilityAndCorporateIdObject;
    if (corporateandfacilityobject === null) {
      corporateandfacilityobject = await getCorporateGroupAndCommunitiesList();
    }
    while (responcesize === pagesize) {
      try {
        if (CommunityContentLoader === false) {
          setCommunityContentLoader(true);
        }

        let organizationEmailId = Speak2UserEmailAsOrganizationId;
        // let isadmin=IsSpeak2Admin;
        const response = await API.get("Community-Content-Templates", "/community-content", {
          response: true,
          queryStringParameters: {
            page: pagenumber,
            limit: pagesize,
            // add more query params as needed
          },
        });
        // console.log("Data for images is ",JSON.stringify(response.data));
        let filteredCommunityContent = response.data.data;
        responcesize = filteredCommunityContent.length;
        totalTemplates = response.data.totalTemplates;

        filteredCommunityContent = response.data.data.filter((template) => {
          // if(organizationEmailId!==null)
          // {
          //   if(template.OrganizationSharedBy===null)
          //   {
          //     return true;
          //   }
          //   return (template.OrganizationSharedBy!==undefined&&template.OrganizationSharedBy.split('@')[1]===Speak2UserEmailAsOrganizationId.split('@')[1]) || template.IsPublic===true || template.IsPublic===undefined;
          // }
          // console.log("tempalte shared to is ",template.TemplateSharedTo);
          if (
            template.IsPublic === false &&
            template.TemplateSharedTo &&
            corporateandfacilityobject != null
          ) {
            console.log("inside the corporate check");
            if (
              corporateandfacilityobject.FacilityId === template.TemplateSharedTo.FacilityId ||
              corporateandfacilityobject.CorporateId === template.TemplateSharedTo.CorporateId
            ) {
              console.log("inside the found the match");
              return true;
            } else {
              console.log("inside the not found the match");
              return false;
            }
          }
          return template.IsPublic === true || template.IsPublic === undefined;
        });

        FilteredCommunityTemplates = FilteredCommunityTemplates.concat(filteredCommunityContent);
      } catch (error) {
        console.log("error fetching design templates", error);
        break;
      }
      pagenumber++;
    }

    // console.log(pagenumber+"We have fetched all of the templates"+totalTemplates+" but total templates are"+FilteredCommunityTemplates.length);
    FilteredCommunityTemplates = handleAddCustomFontsList(FilteredCommunityTemplates);
    setCommunityContentData(FilteredCommunityTemplates);
    setPageSize(FilteredCommunityTemplates.length);
    setTotalNumberOfDesignTemplates(FilteredCommunityTemplates.length);
    setIsLoadedAllCommunityContentTemplates(true);
    setCurrentPage(1);
    setCommunityContentLoader(false);
  };

  // handle get custom fonts and add list

  const handleAddCustomFontsList = (templates) => {
    for (let template of templates) {
      let CustomFontsList = [];
      if (template.TemplateType === "Calendar") {
        for (let Rowitem of template.TemplateData.Calander) {
          for (let CellItem of Rowitem.cells) {
            for (let styleitem of CellItem.styles) {
              if (styleitem.CustomFont && styleitem.CustomFont !== null) {
                if (!CustomFontsList.includes(styleitem.CustomFont.key)) {
                  CustomFontsList.push(styleitem.CustomFont.key);
                }
              }
            }
          }
        }
      } else {
        for (let pageitem of template.TemplateData) {
          for (let ElementItem of pageitem.Elements) {
            if (ElementItem.ElementType === "Table") {
              for (let RowItem of ElementItem.TableDetails) {
                for (let CellItem of RowItem.RowCells) {
                  if (CellItem.CellStyles.CustomFont && CellItem.CellStyles.CustomFont !== null) {
                    if (!CustomFontsList.includes(CellItem.CellStyles.CustomFont.key)) {
                      CustomFontsList.push(CellItem.CellStyles.CustomFont.key);
                    }
                  }
                }
              }
            } else {
              if (ElementItem.Styles[0].CustomFont && ElementItem.Styles[0].CustomFont !== null) {
                if (!CustomFontsList.includes(ElementItem.Styles[0].CustomFont.key)) {
                  CustomFontsList.push(ElementItem.Styles[0].CustomFont.key);
                }
              }
            }
          }
        }
      }
      template.CustomFontsList = CustomFontsList;
    }
    // console.log("Tempalte are here",JSON.stringify(templates));
    return templates;
  };

  const handleShareTemplate = async (
    templatename,
    templatetags,
    templatetype,
    templateimage,
    templatedata,
    IsSharedTemplatePublic,
    OrganizationSharedBy
  ) => {
    // console.log("tempalte name is"+templatename+" and template tags are"+templatetags+"tempalte Type is"+templatetype);
    // console.log("\n Tempalte iamge is"+templateimage);
    // console.log("\n Template data is "+templatedata);
    const formattedDate = moment().format("YYYY-MM-DD");
    // console.log("\n User Name "+UserName);
    let corporateandfacilityobject = FacilityAndCorporateIdObject;
    if (corporateandfacilityobject === null) {
      corporateandfacilityobject = await getCorporateGroupAndCommunitiesList();
    }
    let TemplateSharedTo;
    if (IsSharedTemplatePublic === false) {
      TemplateSharedTo = corporateandfacilityobject;
    }
    let sharedTemplate = {
      TemplateId: CommunityContentData.length + 1,
      TemplateName: templatename,
      CreatedBy: UserName,
      CreatedDate: formattedDate,
      TagsList: templatetags,
      TemplateType: templatetype,
      TemplateImage: templateimage,
      TemplateData: templatedata,
      TemplateRating: null,
      RatedUsersIDs: [],
      TemplateUsedNumber: 0,
      UserId: UserId,
      IsPublic: IsSharedTemplatePublic,
      TemplateSharedTo: TemplateSharedTo,
      OrganizationSharedBy: OrganizationSharedBy,
    };
    let tempaltedata = await handleStoreSharedTemplate(sharedTemplate);
    let updateddata = sharedTemplate;
    if (tempaltedata !== false) {
      updateddata = {
        ...sharedTemplate,
        TemplateId: tempaltedata.TemplateId,
        TemplateImage: tempaltedata.TemplateImage,
      };
    }

    let communitycontent = CommunityContentData;
    communitycontent.push(updateddata);
    setCommunityContentData(communitycontent);
    setCommunityContentLoader(false);
    return true;
  };

  /*
    # handle Store Template in Db
*/
  const handleStoreSharedTemplate = async (Tempaltedata) => {
    setCommunityContentLoader(true);
    let data = [];
    data.push(Tempaltedata);
    let RequestBody = {
      Data: data,
    };

    try {
      const response = await API.post("Community-Content-Templates", "/community-content", {
        body: RequestBody,
        response: true,
      });
      //  console.log("operation Successfull"+response.data);

      return response.data.data;
      //  setLocalStore(response.data.data);
    } catch (error) {
      console.log("Error sharing the template", error);
      // setLocalStore([]);
      return false;
    }
  };
  /*
# handle Update Tempalte USed  and Rating 
*/
  const handleUpdateTemplateUsedAndRating = async (Tempaltedata) => {
    setUpdateTemplateUseAndRatingLoader(true);
    let data = [];
    data.push(Tempaltedata);
    let RequestBody = {
      Data: data,
      TemplateId: Tempaltedata.TemplateId,
    };
    try {
      const response = await API.put("Community-Content-Templates", "/community-content", {
        body: RequestBody,
        response: true,
      });
      setUpdateTemplateUseAndRatingLoader(false);
      return true;
      //  setLocalStore(response.data.data);
    } catch (error) {
      console.log(error);
      // setLocalStore([]);
      setUpdateTemplateUseAndRatingLoader(false);
      return false;
    }
  };

  // handle Detlete Community Content Tempalte
  const handleDeleteCommunityContentBackend = async (Tempaltedata) => {
    let RequestBody = {
      TemplateId: Tempaltedata.TemplateId,
    };

    setUpdateTemplateUseAndRatingLoader(true);
    try {
      const response = await API.del("Community-Content-Templates", "/community-content", {
        body: RequestBody,
        response: true,
      });
      setUpdateTemplateUseAndRatingLoader(false);
      console.log("operation Successfull" + response.data);
      return true;
      //  setLocalStore(response.data.data);
    } catch (error) {
      console.log(error);
      // setLocalStore([]);
      setUpdateTemplateUseAndRatingLoader(false);
      return false;
    }
  };

  // get User Role
  const getUserRole = async () => {
    setCommunityContentLoader(true);
    if (IsSpeak2User === true) {
      LoaderController.show();
    }
    try {
      let response = await getSpeak2Profile();
      if (response != null && response?.data?.Success === true) {
        const content = response.data.Content;
        const activeRole =
          content.Roles?.find((r) => Number(r?.IsActive) === 1) ?? content.Roles?.[0];
        const roleName = activeRole?.Name;
        const isFacilityAdmin =
          roleName === "Facility Admin" && Number(activeRole?.IsActive) === 1;
        let hasFacilityContext = !!content.Facility;
        if (isCorporateProfile(content)) {
          const active = readActiveCorporateFacility(UserId);
          hasFacilityContext = !!active?.facilityId;
        }
        const isCorporateAdmin =
          roleName === "Corporate Admin" && Number(activeRole?.IsActive) === 1;

        const isAdmin = isFacilityAdmin || (isCorporateAdmin && hasFacilityContext);
        setIsSpeak2Admin(isAdmin);
        setCommunityContentLoader(false);
        LoaderController.hide();
        return isAdmin;
      }
      if (IsSpeak2User === true && response?.data?.Success === false) {
        showNotification(
          "Something went wrong while fetching your profile. Please login again.",
          "error",
          4000,
          "top-center"
        );
        handleLogOut();
      }
      setIsSpeak2Admin(false);
      setCommunityContentLoader(false);
      LoaderController.hide();
      return false;
    } catch (error) {
      console.log(error);
      setIsSpeak2Admin(false);
      setCommunityContentLoader(false);
      LoaderController.hide();
      return false;
    }
  };

  // get Corporate Group and Communities List
  const getCorporateGroupAndCommunitiesList = async () => {
    const requestId = ++facilityRequestIdRef.current;
    setCommunityContentLoader(true);
    try {
      setCommunityContentLoader(true);
      const profieresponse = await getSpeak2Profile();
      // console.log("Profile Response is ",JSON.stringify(profieresponse));
      let facilityAndCorporateIdObject;
      if (profieresponse !== null) {
        if (profieresponse.data.Success === true) {
          const content = profieresponse.data.Content;
          let facilityId = content.Facility ?? null;
          if (isCorporateProfile(content)) {
            const active = readActiveCorporateFacility(UserId);
            facilityId = active?.facilityId ?? null;
          }
          facilityAndCorporateIdObject = {
            FacilityId: facilityId,
            CorporateId: content.CorporateId || null,
          };
        }
      }
      console.log("Corporate Group and Communities List is ", facilityAndCorporateIdObject);
      setCommunityContentLoader(false);
      if (requestId === facilityRequestIdRef.current) {
        setFacilityAndCorporateIdObject(facilityAndCorporateIdObject);
      }
      return facilityAndCorporateIdObject;
    } catch (error) {
      setCommunityContentLoader(false);
      if (requestId === facilityRequestIdRef.current) setFacilityAndCorporateIdObject(null);
      console.log("error Fetching Corporate Group and Communities List", error);
      return null;
    }
  };

  const getUserOrganizationEmail = async () => {
    try {
      let response = await getSpeak2Profile();

      if (response.data.Success === true) {
        let emailDomain = response.data.Content.Email.split("@")[1];
        let commonEmailDomains = [
          "gmail.com",
          "yahoo.com",
          "hotmail.com",
          "outlook.com",
          "aol.com",
          "icloud.com",
          "protonmail.com",
          "zoho.com",
          "yandex.com",
          "speak2family.com",
        ];
        console.log("Email Domain is " + emailDomain);
        if (commonEmailDomains.indexOf(emailDomain) === -1) {
          console.log("User email is corporate email");
          setSpeak2UserEmailAsOrganizationId(response.data.Content.Email);
          return response.data.Content.Email;
        } else {
          console.log("User email is not corporate email");
          setSpeak2UserEmailAsOrganizationId(null);
          return null;
        }
      }
      return null;
    } catch (error) {
      console.log(error);
      setSpeak2UserEmailAsOrganizationId(null);
      return null;
    }
  };
  let ContextData = {
    CommunityContentData: CommunityContentData,
    CommunityContentLoader: CommunityContentLoader,
    UpdateTemplateUseAndRatingLoader: UpdateTemplateUseAndRatingLoader,
    IsSpeak2Admin: IsSpeak2Admin,
    NumberOfPagesToDisplayOnPagination: NumberOfPagesToDisplayOnPagination,
    PageSize: PageSize,
    TotalNumberOfDesignTemplates: TotalNumberOfDesignTemplates,
    CurrentPage: CurrentPage,
    IsLoadedAllCommunityContentTemplates: IsLoadedAllCommunityContentTemplates,
    FacilityAndCorporateIdObject: FacilityAndCorporateIdObject,
    setCurrentPage: setCurrentPage,
    getUserRole: getUserRole,
    getUserOrganizationEmail: getUserOrganizationEmail,
    setUpdateTemplateUseAndRatingLoader: setUpdateTemplateUseAndRatingLoader,
    setCommunityContentData: setCommunityContentData,
    handleShareTemplate: handleShareTemplate,
    handleUpdateTemplateUsedAndRating: handleUpdateTemplateUsedAndRating,
    handleDeleteCommunityContentBackend: handleDeleteCommunityContentBackend,
    Speak2UserEmailAsOrganizationId: Speak2UserEmailAsOrganizationId,
    getCommunityContentTemplates: getCommunityContentTemplates,
    getCommunityContentTemplatesPaginated: getCommunityContentTemplatesPaginated,
    loadAllCommunityContentTemplates: loadAllCommunityContentTemplates,
  };
  return <ShareContext.Provider value={ContextData}>{children}</ShareContext.Provider>;
};
